export const MeetingStatusEnum = {
    CLOSED: 'CLOSED',
    FINISHED: 'FINISHED',
    STARTED: 'STARTED',
    NEW: 'STARTED', 
    CANCELLED: 'CANCELLED'
  };
  